
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0)"}},[_c('path',{attrs:{"d":"M14.286.001H1.714C.768.001 0 .768 0 1.715v9.143c0 .947.768 1.714 1.714 1.714h2.029l-.311 2.795a.571.571 0 00.95.487l3.647-3.282h6.257c.947 0 1.714-.767 1.714-1.714V1.715c0-.947-.768-1.714-1.714-1.714z","fill":"#6C6C6C"}})])])
          )
        }
      }
    